import memoize from 'fast-memoize';
import { createSelector } from 'reselect';

import { State } from '../Store';

export const selectProducts = (state: State) => state.products || [];

export const selectProduct = memoize((id: number | null) =>
  id
    ? createSelector(
        [selectProducts],
        products => products.find(product => product.id === id)
      )
    : () => undefined
);

/**
 * A lot of products have very specific sizes or data is missing
 * this is why we are only taking the truck tires (filterable by
 * the product code "starts with P"). These tires usually have the
 * sizing marked well.
 */
export const selectUniqueProductSizes = createSelector(
  [selectProducts],
  products =>
    Array.from(
      new Set(
        products
          .filter(product => product.code.startsWith('P'))
          .sort((a, b) =>
            +a.surface_size.replace(/\D+/g, '') > +b.surface_size.replace(/\D+/g, '') ? -1 : 1
          )
          .map(product => product.size)
      )
    )
);
